import { render, staticRenderFns } from "./GamesSearchComponent.vue?vue&type=template&id=1c2e4861"
import script from "./GamesSearchComponent.vue?vue&type=script&lang=js"
export * from "./GamesSearchComponent.vue?vue&type=script&lang=js"
import style0 from "./scss/styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports